import React, { useEffect } from 'react';
import { GeckoCard, Spinner } from '../../components';
import Logout from '../../services/Logout';

const LogoutPage = () => {
    useEffect(() => {
        Logout();
    }, []);

    return (
        <GeckoCard>
            <div className="row text mt-3 mb-3">
                <div className="col d-flex flex-column align-items-center">
                    <Spinner size="small" />
                </div>
            </div>
        </GeckoCard>
    );
};

export default LogoutPage;